import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
// import MainComponent from './Components/MainComponent';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <BrowserRouter>
      <ToastContainer />
      <App />
      {/* <MainComponent /> */}
    </BrowserRouter>
  </>
);
